import styled from '@emotion/styled';
import type { FC } from 'react';

import type { ChartCellProps } from '../types';

const ChartImage = styled('img')({
  width: '100%',
  height: '76%',
  objectFit: 'contain',
  display: 'block',
});

export const ChartCell: FC<ChartCellProps> = ({ src, alt = '' }) => {
  return <ChartImage src={src} alt={alt} />;
};

ChartCell.displayName = 'ChartCell';
